// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { icon } from '../../tokens/themeColors/icon';
import { text } from '../../tokens/themeColors/text';
export var listColors = function(mode) {
    var bg = background(mode);
    var ic = icon(mode);
    var tx = text(mode);
    return {
        // Figma: List/Background. Not wired in List.tsx — MUI's List root inherits
        // its surface from the containing Paper/Card rather than painting its own.
        // Consumers that render a standalone list reference it directly.
        background: bg.level100,
        icon: ic.active,
        text: tx.primary,
        secondaryText: tx.secondary,
        subheaderBackground: {
            level0: bg.level0,
            level50: bg.level50,
            level100: bg.level100,
            level200: bg.level200,
            level300: bg.level300
        }
    };
};

//# sourceMappingURL=listColors.js.map